var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"integration-container"}},[_c('h1',[_vm._v("Integration "+_vm._s(_vm.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }